import { Injectable } from '@angular/core';
import { HttpClient } from './http-client.service';
import { Address, PageableSearch, OpenItem, OpenItemPayment, Reversal } from '../../models';
import { Logger } from '../logger.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { ErrorHandlerService } from '../error-handler.service';
import { AppState } from "../../reducers";
import { MessageActions } from '../../actions';
import { Store } from '@ngrx/store';

let FileSaver = require('../../FileSaver');

export interface OpenItemQuery {
	invoiceAddress: string
	customerFullName: string
	invoiceDateFrom: string
	invoiceDateTo: string
	invoiceNumber: string,
	orderNumber: string
	invoicePosition: string
	checkoutRef: string
	fullyPaid?:boolean,
	page: number,
	sort: string
}

@Injectable()
export class OpenItemApi {
	private openItemApi = '/api/finance/v1/openItems';
	private invoicesPdfApi = '/api/finance/v1/invoicesPdf';

	constructor(
		private httpClient: HttpClient,
		private logger: Logger,
		private errorHandler: ErrorHandlerService,
		private store$: Store<AppState>,
		private messageActions: MessageActions
	) {}


	public search(query: OpenItemQuery): Observable<PageableSearch<OpenItem>> {
		const url = this.buildSearchUrl(query);
		return this.httpClient.get(url).map(response => response.json());
	}

	public loadOpenItemById(uuid: string): Observable<OpenItem> {
		this.logger.info("Get open item by uuid:" + uuid);
		return this.httpClient.get(this.openItemApi + "/" + uuid)
			.map(response => <OpenItem>response.json())
			.catch(this.handleError);
	}

	private buildSearchUrl(query: OpenItemQuery) {
		let url =  this.openItemApi + "/search/fullSearch" + "?"
		if (query.invoiceAddress)
			url += "&invoiceAddress=" + query.invoiceAddress
		if (query.customerFullName)
			url += "&customerFullName=" + query.customerFullName
		if (query.invoiceDateFrom)
			url += "&invoiceDateFrom=" + query.invoiceDateFrom
		if(query.invoiceDateTo)
			url += "&invoiceDateTo=" + query.invoiceDateTo
		if (query.invoiceNumber)
			url += "&invoiceNumber=" + query.invoiceNumber
		if (query.orderNumber)
			url += "&orderNumber=" + query.orderNumber
		if (query.invoicePosition)
			url += "&invoicePosition=" + query.invoicePosition
		if (query.checkoutRef)
			url += "&checkoutRef=" + query.checkoutRef
		if (query.fullyPaid === false || query.fullyPaid === true)
			url += "&fullyPaid=" + query.fullyPaid
		if (query.sort)
			url += "&sort=" + query.sort
		url += "&page=" + query.page
		return url;
	}

	public createMissingPayment(uuid: string): Observable<OpenItem> {
		this.logger.info("Create missing payment for open item with uuid:" + uuid);
		let url = this.openItemApi + "/" + uuid + "/createMissingPayment"
		return this.httpClient.post(url)
			.map(response => <OpenItem>response.json())
			.catch(this.handleError)
	}

	public createPayment(uuid: string, payment: OpenItemPayment): Observable<OpenItem> {
		this.logger.info("Create payment for open item with uuid:" + uuid + " and value: " + payment.value);
		let url = this.openItemApi + "/" + uuid + "/createPayment"
		let body = JSON.stringify(payment)
		return this.httpClient.post(url, body)
			.map(response => <OpenItem>response.json())
			.catch(this.handleError)
	}

	public createInvoiceCorrection(uuid: string, reversal: Reversal): Observable<any> {
		this.logger.info("Create invoice correction for open item with uuid:" + uuid );
		let url = this.openItemApi + "/" + uuid + "/reversal"
		let body = JSON.stringify(reversal)
		return this.httpClient.post(url, body)
			.map(response => <any>response.json())
			.catch(this.handleError)
	}

	public getBlob(requestPath: string): Observable<Blob> {
		return this.httpClient.getFileAsBlob(requestPath)
			.map(response => response.blob())
			.catch(this.handleError);
	}

	// This function builds the path with the invoicePdfApi because we download only invoice- and invoice-correction-pdfs.
	// If we want the function to download all pdfs, we have to move it into a separate service.
	public downloadPdf(requestPath: string, fileName: string, errorText: string) {
		this.getBlob(this.invoicesPdfApi + requestPath).subscribe(blob => {
			FileSaver.saveAs(blob, fileName + ".pdf");
		}, error => {
				let errorMessage = this.errorHandler.getErrorMessage(error, errorText)
				this.store$.dispatch(this.messageActions.displayMessage(errorMessage, "error"))
			})
	}

	private handleError = (error: Response) => {
		this.logger.error(error);
		return Observable.throw(error);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/webservice/open-item-api.service.ts